export const GET_ORDER = 'GET_ORDER'
export const ACCEPT_CONDITIONS = 'ACCEPT_CONDITIONS'